import { useEffect, useRef, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import instance from '../helpers/interceptor';

const TIMEOUT_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds
const WARNING_DURATION = 2 * 60 * 1000; // 2 minutes warning before timeout

const useSessionTimeout = () => {
  const { instance: msalInstance } = useMsal();
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);

    warningRef.current = setTimeout(() => {
      setShowTimeoutModal(true);
    }, TIMEOUT_DURATION - WARNING_DURATION);

    timeoutRef.current = setTimeout(() => {
      handleLogout('timeout');
    }, TIMEOUT_DURATION);
  };

  const handleLogout = async (reason = 'manual') => {
    // Call backend to clear session from DynamoDB
    try {
      await instance.post('/login/logout');
    } catch {
      // Silently fail - session might already be invalid
    }

    sessionStorage.clear();
    
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + '/'
    });
  };

  const handleContinueSession = () => {
    setShowTimeoutModal(false);
    resetTimer();
  };

  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

  useEffect(() => {
    resetTimer();

    const resetTimerOnActivity = () => {
      if (!showTimeoutModal) {
        resetTimer();
      }
    };

    events.forEach(event => {
      document.addEventListener(event, resetTimerOnActivity, true);
    });

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (warningRef.current) clearTimeout(warningRef.current);
      
      events.forEach(event => {
        document.removeEventListener(event, resetTimerOnActivity, true);
      });
    };
  }, [showTimeoutModal]);

  return {
    showTimeoutModal,
    handleLogout,
    handleContinueSession
  };
};

export default useSessionTimeout;
